export default __webpack_public_path__ + "static/media/iconFileAll.bcb6790d.svg";